import { createSlice } from "@reduxjs/toolkit"
import { IOptionsState } from "./types"
import { fetchOptions } from "./optionsThunk"
import { WordPressOptions } from "@/shared/types/wordpress"

const initialState: IOptionsState = {
	companyLogo: "",
	companyName: "",
	companyAddress: "",
	companyPhone: "",
	workTime: "",
	workDays: "",
	creditRate: "",
	privacyPolicy: "",
	graphColor: "",
	buttonColor: "",
}

const optionsSlice = createSlice({
	name: "options",
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchOptions.fulfilled, (state, action) => {
			const data: WordPressOptions = action.payload
			state.companyLogo = data.logo || ""
			state.companyName = data.company_name || ""
			state.companyAddress = data.address || ""
			state.companyPhone = data.phone || ""
			state.workTime = data.working_hours || ""
			state.workDays = data.working_days || ""
			state.creditRate = data.credit_rate || ""
			state.addFilters = data.add_filters || false
			state.graphColor = data.graph_color || ""
			state.buttonColor = data.button_color || ""
			state.privacyPolicy = data.privacy_policy || ""
		})
	},
})

export default optionsSlice.reducer
